<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title" *ngIf="inner_Cabinent.id==0">Register Cabinet</h5>
      <h5 class="card-title" *ngIf="inner_Cabinent.id>0">Edit Cabinet</h5>
      <form [formGroup]="FormCabinet" (submit)="SubmitFormCabinet()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Location</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Please enter a location.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Code Number</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Please enter a code number.</small>
          </div>
        </div>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && inner_Cabinent.id==0" type="submit" [disabled]="!FormCabinet.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
        <button *ngIf="!InProccessing && inner_Cabinent.id>0" type="submit" [disabled]="!FormCabinet.valid" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Information </button>

      </form>
  </div>
</div>
